import { useEffect, useRef } from 'react';

import { useAtom } from 'jotai';

import { useTracking } from '@consumer-frontend/nc-api';
import { genericErrorMessage, isDefined } from '@consumer-frontend/nc-utils';

import {
  accountIdAtom,
  paymentFailureDataAtom,
} from '../../store';
import { NcErrorPage } from '../NcErrorPage';

export const NcPaymentError: React.FC = () => {
  const [accountId] = useAtom(accountIdAtom);
  const { trackEvent } = useTracking(accountId);
  const hasFiredTrackingEvent = useRef(false);
  const [paymentFailureData, setPaymentFailureData] = useAtom(paymentFailureDataAtom);

  // Clear payment failure data on mount
  useEffect(
    () => {
      if (!isDefined(paymentFailureData) || hasFiredTrackingEvent.current) { return; }

      hasFiredTrackingEvent.current = true;
      // This setTimeout is necessary to ensure the page transition happening simultaneously completes
      // before the trackEvent fires in order to associate the event with the correct page_view_id.
      setTimeout(
        async () => {
          try {
            await trackEvent(paymentFailureData);
          } catch {
            /* Swallow tracking errors */
          }
        },
        1000,
      );
      setPaymentFailureData(() => undefined);
    },
    [
      paymentFailureData,
      setPaymentFailureData,
      trackEvent,
    ],
  );

  return (
    <NcErrorPage
      message={genericErrorMessage}
      displaySupportText
      heading="Make a Payment"
    />
  );
};
